import { Select, FormControl, InputLabel, FormHelperText, IconButton } from "@mui/material";
import { useField, useFormikContext } from "formik";
import CloseIcon from "@mui/icons-material/Close";

interface InputSelectFieldInterfaceProps {
   label?: string;
   labelId?: string;
   fullWidth?: boolean;
   multiple?: boolean;
   id: string;
   name: string;
   renderValue?: any;
   children: any;
   variant?: any;
   required?: boolean;
   clearname?: string;
   onChange?: (e: React.ChangeEvent<any>) => void;
   disabled?: boolean;
}

export const InputSelectField = (props: InputSelectFieldInterfaceProps) => {
   const [field, meta] = useField(props);
   const { values, setFieldValue } = useFormikContext();
   return (
      <FormControl fullWidth={props.fullWidth} required={props.required}>
         {props.label ? (
            <InputLabel id={props.labelId} sx={{ mx: -1.5 }}>
               {props.label}
            </InputLabel>
         ) : (
            <></>
         )}
         <Select
            IconComponent={
               props.clearname && values[props.clearname].length > 1
                  ? () => (
                       <IconButton
                          size="small"
                          onClick={(e) => {
                             setFieldValue(props.clearname, "");
                          }}
                       >
                          <CloseIcon />
                       </IconButton>
                    )
                  : undefined
            }
            MenuProps={{ style: { maxHeight: "370px" } }}
            sx={{ minWidth: { xs: "20vw", md: 200 } }}
            error={meta.error && meta.touched}
            {...props}
            {...field}
         >
            {props.children}
         </Select>
         <FormHelperText error={meta.error && meta.touched}>
            {meta.error && meta.touched ? meta.error : null}
         </FormHelperText>
      </FormControl>
   );
};
